import { styled } from 'styled-components';

import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';

export const OrgLogoLink = styled(StyledVersionedRouterLink)`
  align-self: start;
`;
